import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  EmperorCardTypes,
  EmperorUIButtonTypes,
} from '@boldpenguin/emperor-presentational';

import { Store } from '@ngrx/store';
import {
  ResendUserInviteAction,
  UpdateUserAction,
} from 'src/app/core/store/user-settings/users.actions';
import { ITerminalUser } from 'src/app/features/settings/models/user.model';
import { IUserDetails } from '../../models/user-details.model';
import {
  convertFormToITerminalUser,
  isUserDeactivated,
} from '../../utilities/user-utilities';

@Component({
  selector: 'app-user-expansion-panel',
  templateUrl: './user-expansion-panel.component.html',
  styleUrl: './user-expansion-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserExpansionPanelComponent implements OnChanges {
  @Input() user: ITerminalUser;
  @Input() canEdit = false;
  @Input() delayInvite = false;
  @Input() isFTW = false;
  isPanelExpanded = false;
  isEditing = false;
  isUserDeactivated = false;
  readonly EmperorCardTypes = EmperorCardTypes;
  readonly EmperorUIButtonTypes = EmperorUIButtonTypes;
  private store = inject(Store);

  ngOnChanges(changes: SimpleChanges) {
    if (changes.user) {
      this.isUserDeactivated = isUserDeactivated(changes.user.currentValue);
      this.closeEditView();
      if (this.isUserDeactivated) {
        this.toggleExpanded(false);
      }
    }
  }

  edit() {
    this.isEditing = true;
    this.toggleExpanded(true);
  }

  updateUser(userDetails: IUserDetails) {
    const userToDispatch = convertFormToITerminalUser(userDetails, this.user);
    if (this.isUserDeactivated) {
      this.store.dispatch(
        ResendUserInviteAction({
          user: userToDispatch,
          delayInvite: this.delayInvite,
        }),
      );
    }
    this.store.dispatch(
      UpdateUserAction({ user: userToDispatch, isFTW: this.isFTW }),
    );
  }

  closeEditView() {
    this.isEditing = false;
  }

  toggleExpanded(isExpanded: boolean) {
    this.isPanelExpanded = isExpanded;
  }
}
